module.exports = __webpack_public_path__ + "img/charging-hub-rejected-private.121c6284.png";